import { HttpLink, ApolloClient, InMemoryCache } from '@apollo/client';
import { ApolloProvider } from '@apollo/client'
import { useAuth0 } from "@auth0/auth0-react";
import { setContext } from "@apollo/client/link/context";
import React, { useEffect, useState } from 'react';
import fetch from 'isomorphic-fetch';
import { AccessTokenProvider } from '@shapeable/ui';

export const AuthorizedApolloProvider = ({ children }: any) => {
  const httpLink = new HttpLink({
    uri: process.env.GRAPHQL_SERVER,
    fetch,
  });

  const [accessToken, setAccessToken] = useState('')
  const [client, setClient] = useState() as [ApolloClient<any>, any]
  const { getAccessTokenSilently, isLoading, isAuthenticated } = useAuth0();

  const fallbackClient = new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
    connectToDevTools: true,
  });

  // get access token
  useEffect(() => {
    const getAccessToken = async () => {
      try {
        // checking if authenticated prevents an infinite loop when logging in
        if (isAuthenticated) {
          const token = await getAccessTokenSilently();
          setAccessToken(token);
        }
      } catch (e) {
        console.log(e)
      }
    };
    getAccessToken();
  }, [isAuthenticated])

  useEffect(() => {
    const authLink = setContext((_, { headers }) => {
      const token = accessToken;

      const baseHeaders = {
        ...headers,
        accesskey: process.env.GRAPHQL_ACCESS_KEY,
      };

      if (token) {
        return {
          headers: {
            ...baseHeaders,
            authorization: `Bearer ${token}`,
          },
        }
      } else {
        return {
          headers: {
            ...baseHeaders,
          },
        }
      }
    });

    const client = new ApolloClient({
      link: authLink.concat(httpLink),
      cache: new InMemoryCache(),
      connectToDevTools: true,
    })

    setClient(client)
  }, [accessToken])
 
  return (
    <AccessTokenProvider value={accessToken}>
    <ApolloProvider client={client || fallbackClient}>
      {children}
    </ApolloProvider>
    </AccessTokenProvider>
  );

};

export default AuthorizedApolloProvider;